










































































import { Vue, Component } from 'vue-property-decorator';

import requestStoreModule from '@/modules/requests/store';

import theme from '@/services/theme';

@Component
export default class Widgets extends Vue {
    private windowClickListener: undefined | ((this: Window, ev: MouseEvent) => void);
    public path = '';
    public currentTime = new Date();

    public srcInfo = '/img/light-theme/main/infopanel_off_light.png';
    public srcDiagram = '/img/light-theme/main/diagram_off_light.png';
    public srcMail = '/img/light-theme/main/message_off_light.png';
    public srcVideo = '/img/light-theme/main/video_off_light.png';
    public srcMap = '/img/light-theme/main/map_off_light.png';
    public srcNewsMonitor = '/img/light-theme/main/diagram_off_light.png';

    public created() {
        this.windowClickListener = () => {
            this.path = '';
        };
        window.addEventListener('click', this.windowClickListener);

        this.$watch('themeDark', () => {
            if (theme.dark) {
                this.srcInfo = '/img/dark-theme/main/infopanel_off.svg';
                this.srcDiagram = '/img/dark-theme/main/diagram_off.svg';
                this.srcMail = '/img/dark-theme/main/mail_off.svg';
                this.srcVideo = '/img/dark-theme/main/video_off.svg';
                this.srcMap = '/img/dark-theme/main/map_off.svg';
                this.srcNewsMonitor = '/img/dark-theme/main/diagram_off.svg';
            } else {
                this.srcInfo = '/img/light-theme/main/infopanel_off_light.png';
                this.srcDiagram = '/img/light-theme/main/diagram_off_light.png';
                this.srcMail = '/img/light-theme/main/message_off_light.png';
                this.srcVideo = '/img/light-theme/main/video_off_light.png';
                this.srcMap = '/img/light-theme/main/map_off_light.png';
                this.srcNewsMonitor = '/img/light-theme/main/diagram_off_light.png';
            }
        });

        this.$watch('path', () => {
            switch (this.path) {
                case '/plashki':
                    this.srcInfo = (this.themeDark ? '/img/dark-theme/main/infopanel_on.svg' : '/img/light-theme/main/infopanel_on_light.png');
                    break;
                case '/datas':
                    this.srcDiagram = (this.themeDark ? '/img/dark-theme/main/diagram_on.svg' : '/img/light-theme/main/diagram_on_light.png');
                    break;
                case '/requests':
                    this.srcMail = (this.themeDark ? '/img/dark-theme/main/mail_on.svg' : '/img/light-theme/main/message_on_light.png');
                    break;
                case '/media':
                    this.srcVideo = (this.themeDark ? '/img/dark-theme/main/video_on.svg' : '/img/light-theme/main/video_on_light.png');
                    break;
                case '/astanamap':
                    this.srcMap = (this.themeDark ? '/img/dark-theme/main/map_on.svg' : '/img/light-theme/main/map_on_light.png');
                    break;
                case '/news-monitor':
                    this.srcNewsMonitor = (this.themeDark ? '/img/dark-theme/main/diagram_on.svg' : '/img/light-theme/main/diagram_on_light.png');
                    break;
                default:
                    if (this.themeDark) {
                        this.srcInfo = '/img/dark-theme/main/infopanel_off.svg';
                        this.srcDiagram = '/img/dark-theme/main/diagram_off.svg';
                        this.srcMail = '/img/dark-theme/main/mail_off.svg';
                        this.srcVideo = '/img/dark-theme/main/video_off.svg';
                        this.srcMap = '/img/dark-theme/main/map_off.svg';
                        this.srcNewsMonitor = '/img/dark-theme/main/diagram_off.svg';
                    } else {
                        this.srcInfo = '/img/light-theme/main/infopanel_off_light.png';
                        this.srcDiagram = '/img/light-theme/main/diagram_off_light.png';
                        this.srcMail = '/img/light-theme/main/message_off_light.png';
                        this.srcVideo = '/img/light-theme/main/video_off_light.png';
                        this.srcMap = '/img/light-theme/main/map_off_light.png';
                        this.srcNewsMonitor = '/img/light-theme/main/diagram_off_light.png';
                    }
            }
        });
    }

    public mounted() {
        const currentTimeUpdate = () => {
            this.currentTime = new Date();
        };

        setInterval(currentTimeUpdate, 1000);
    }

    public destroyed() {
        if (this.windowClickListener !== undefined) {
            window.removeEventListener('click', this.windowClickListener);
        }
    }

    // время
    public get dateTimeFormat(): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat(this.$i18n.locale, {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric'
        });
    }

    // Обращения
    public get wipRequestCount(): number {
        return requestStoreModule.wipCount;
    }

    // переключение темы
    private get themeDark(): boolean {
        return theme.dark;
    }
}
